const becomeSellerEn = {
  breadcrumbs: {
    home: 'Home',
    becomeSeller: 'Become a Seller'
  },
  hero: {
    title: 'Become a Seller',
    subtitle: 'Grow your business with Grameen Bazar and reach millions of customers',
    cta: 'Get Started Now'
  },
  stats: [
    { value: '50,000+', label: 'Active Sellers' },
    { value: '98%', label: 'On-time Payments' },
    { value: '300%', label: 'Avg. Sales Growth' },
    { value: '4.8/5', label: 'Seller Satisfaction' }
  ],
  benefits: {
    title: 'Benefits of Selling',
    items: [
      { title: 'Increase Sales', description: 'Reach our 1M+ customers with your products' },
      { title: 'Earn More', description: 'Competitive commission rates and fast payments' },
      { title: '24/7 Support', description: 'Our dedicated seller support team is always with you' },
      { title: 'Secure Transactions', description: 'Fully secure and transparent payment system' },
      { title: 'Quick Setup', description: 'Launch your shop within 24 hours' },
      { title: 'Sales Analytics', description: 'Detailed reports and sales tracking' }
    ]
  },
  steps: {
    title: 'How to Start',
    stepNumbers: ['1', '2', '3'],
    items: [
      { title: 'Registration', description: 'Register with your personal and business information' },
      { title: 'Verification', description: 'Our team verifies your info and approves within 24 hours' },
      { title: 'Start Selling', description: 'Upload products and start selling' }
    ]
  },
  cta: {
    title: 'Start Your Digital Business Today',
    subtitle: 'Join with Grameen Bazar and take your business to new heights',
    button: 'Join as a Seller'
  },
  transformDreams: {
    title: 'Transform Your Dreams with Grameen Bazar',
    content: [
      'Imagine watching your business flourish—not just with familiar faces, but with new customers from every village, each discovering you for the first time. At Grameen Bazar, your products become part of daily life for people who have never shopped at a marketplace before.',
      'Our powerful marketing reaches deep into rural communities, bringing together neighbors and friends who want to support local sellers—like you. Our latest survey revealed something incredible: nearly 30% of our buyers are first-time marketplace customers, ready and eager to buy from you.',
      'This is a chance you\'ve never had before—connecting with people who were out of reach, welcoming them into your story, and growing your sales by 50% to 100% or more. Join Grameen Bazar—not just as a platform, but as a movement.',
      'Let\'s bring hope, opportunity, and prosperity to your family, your village, and your dreams. The customers are waiting. It\'s your turn to shine.'
    ]
  }
};

export default becomeSellerEn;


